import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../material/material.module';
import { CommonHeaderComponent } from './common-header/common-header.component';
import { FooterComponent } from './footer/footer.component';
import { MultiDataComponent } from './multi-data/multi-data.component';
import { MathjaxModule } from 'mathjax-angular';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { SatPopoverModule } from '@ncstate/sat-popover';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { ContainerHeaderComponent } from './container-header/container-header.component';
import { KatexModule } from 'ng-katex';
import { FullCalendarModule } from '@fullcalendar/angular';
import { TimePipe } from 'src/app/pipes/time.pipe';
import { MathjaxEditorComponent } from './mathjax-editor/mathjax-editor.component';

@NgModule({
  declarations: [
    CommonHeaderComponent,
    FooterComponent,
    MultiDataComponent,
    ContainerHeaderComponent,
    TimePipe,
    MathjaxEditorComponent,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MaterialModule,
    RouterModule,
    CommonModule,
    MathjaxModule.forChild(),
    NgxDocViewerModule,
    PdfViewerModule,
    AutocompleteLibModule,
    NgxMatTimepickerModule,
    AngularEditorModule,
    SatPopoverModule,
    KatexModule,
    FullCalendarModule,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    CommonHeaderComponent,
    FooterComponent,
    MultiDataComponent,
    NgxDocViewerModule,
    PdfViewerModule,
    AutocompleteLibModule,
    NgxMatTimepickerModule,
    AngularEditorModule,
    SatPopoverModule,
    NgxIntlTelInputModule,
    ContainerHeaderComponent,
    KatexModule,
    FullCalendarModule,
    TimePipe,
    MathjaxEditorComponent,
  ],
})
export class CommonlyUsedModule {}
